import { call, put, takeEvery } from "redux-saga/effects";

import {
  CLIENT_LIST,
  CLIENT_CREATE,
  CLIENT_FILTER,
  CLIENT_UPDATE,
} from "store/clients/actionTypes";

import {
  clientListSuccess,
  clientCreateSuccess,
  clientUpdateSuccess,
  clientRequestFailed,
} from "store/clients/actions";

import {
  getClientList,
  postClientCreate,
  getClientFilter,
  patchClientUpdate
} from "connection/backend";

function* clientListSaga() {
  console.log("Trayendo lista de clientes...");
  try {
    const response = yield call(getClientList);
    if (response.status === 200) {
      yield put(clientListSuccess(response.data));
    } else {
      yield put(clientRequestFailed(response.data));
    }
  } catch (error) {
    yield put(clientRequestFailed(error.response.data));
  }
}

function* clientCreateSaga({ payload: user }) {
  console.log("Creando nuevo cliente...");
  try {
    const response = yield call(postClientCreate, user);
    if (response.status === 201) {
      yield put(clientCreateSuccess(response.data));
    } else {
      yield put(clientRequestFailed(response.data));
    }
  } catch (error) {
    yield put(clientRequestFailed(error.response.data));
  }
}

function* clientFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getClientFilter, { changeUrl });
    if (response.status === 200) {
      yield put(clientListSuccess(response.data));
    } else {
      yield put(clientRequestFailed(response.data));
    }
  } catch (error) {
    yield put(clientRequestFailed(error.response.data));
  }
}

function* clientUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del cliente...");
  try {
    const response = yield call(patchClientUpdate, { id }, data);
    if (response.status === 200) {
      yield put(clientUpdateSuccess(response.data));
    } else {
      yield put(clientRequestFailed(response.data));
    }
  } catch (error) {
    yield put(clientUpdateSuccess(error.response.data));
  }
}

export default function* clientSaga() {
  yield takeEvery(CLIENT_LIST, clientListSaga);
  yield takeEvery(CLIENT_CREATE, clientCreateSaga);
  yield takeEvery(CLIENT_FILTER, clientFilterSaga);
  yield takeEvery(CLIENT_UPDATE, clientUpdateSaga);
}
